import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { INotificationActionResult } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import { IMessagesUploadState, getInitialMessagesUploadState, IMessagesUploadError } from "./MessagesUpload.state";

const initialState = getInitialMessagesUploadState();

export const messagesUploadManager = createSlice({
  name: "messagesUpload",
  initialState: initialState,
  reducers: {
    uploadMessages: (state: IMessagesUploadState, _action: PayloadAction<File[]>) => {
      return {
        ...state,
        uploadProcessing: true,
        uploadCompleted: false,
        notifications: [],
        error: undefined,
        progress: 1
      };
    },
    uploadMessagesProcessing: (state: IMessagesUploadState, action: PayloadAction<number>) => {
      return {
        ...state,
        progress: action.payload
      };
    },
    resetUploadingMessages: () => {
      return initialState;
    },
    uploadMessagesCompleted: (state: IMessagesUploadState) => {
      return {
        ...state,
        uploadProcessing: false,
        uploadCompleted: true
      };
    },
    uploadMessagesFailed: (state: IMessagesUploadState, action: PayloadAction<INotificationActionResult<IMessagesUploadError>>) => {
      return {
        ...state,
        progress: 0,
        uploadProcessing: false,
        uploadCompleted: true,
        notifications: action.payload.notification ? [action.payload.notification] : [],
        error: action.payload.data
      };
    },
    uploadMessagesError: (state: IMessagesUploadState, action: PayloadAction<INotification>) => {
      return { ...state, progress: 0, uploadProcessing: false, notifications: [action.payload] };
    }
  },
  extraReducers: getScreenExtraReducers<IMessagesUploadState>("notifications", initialState)
});
